import { useCallback, useEffect, useRef, useState } from "react";
const BASE = process.env.REACT_APP_BACKEND_URL;

export const useFullBrief = (id, user, authLoading, generateIntent) => {
  const [state, setState] = useState({ status: "loading", data: null, preview: null, error: "" });
  const controller = useRef(null);
  const load = useCallback(async (allowGeneration = false) => {
    controller.current?.abort(); const abort = new AbortController(); controller.current = abort;
    setState({ status: "loading", data: null, preview: null, error: "" });
    let requested = false;
    const read = (generate = false) => fetch(`${BASE}/api/story/${encodeURIComponent(id)}/brief${generate ? "/generate" : ""}`, {
      credentials: "include", signal: abort.signal, method: generate ? "POST" : "GET",
      ...(generate ? { headers: { "Content-Type": "application/json" }, body: "{}" } : {}),
    });
    try {
      let response = await read();
      for (let polls = 0; polls < 80; polls++) {
        const body = await response.json().catch(() => ({}));
        if (abort.signal.aborted) return;
        if ([401, 402, 403].includes(response.status)) { setState({ status: "locked", preview: body.detail?.story || null, data: null }); return; }
        if (!response.ok) throw new Error(typeof body.detail === "string" ? body.detail : "This brief could not be prepared. Please retry.");
        if (body.brief) { setState({ status: "ready", data: body, preview: null }); return; }
        if (body.status === "not_ready") {
          if (requested) throw new Error("Brief preparation did not complete. Please retry.");
          if (!allowGeneration) { setState({ status: "not_ready", data: body, preview: body }); return; }
          requested = true; setState({ status: "preparing", preview: body, data: null });
          response = await read(true); continue;
        }
        setState(prev => ({ ...prev, status: "preparing" }));
        await new Promise(resolve => setTimeout(resolve, 2000));
        if (abort.signal.aborted) return;
        response = await read();
      }
      throw new Error("The brief is still being prepared. Check again shortly.");
    } catch (e) { if (!abort.signal.aborted) setState(prev => ({ ...prev, status: "error", error: e.message })); }
  }, [id]);
  useEffect(() => {
    if (!authLoading) load(!!generateIntent);
    return () => controller.current?.abort();
  }, [load, authLoading, user?.user_id, user?.subscription_tier, generateIntent]);
  return { ...state, prepare: () => load(true), check: () => load(false) };
};